import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message, PrizeSpacer, ValidatingInput, Heading, Text, Button, LoadingInspector, getMessage } from "..";
import Formsy from '../../external/Formsy';
import LegalActions from "../../actions/LegalActions";
import LegalFormSchema from "../../data/schema/LegalFormSchema";

const LegalContentWrapper = ({ getGuardianInfo, legalState, updateGuardianInfo, messages }) => {
    useEffect(() => {
        getGuardianInfo();
    }, []);

    const updateGuardianInfoAct = (guardianData) => {
        updateGuardianInfo(guardianData);
    };

    const [form, setForm] = React.useState({
        guardianFirstName: "",
        guardianLastName: "",
        guardianEmail: "",
        guardianPhoneNumber: ""
    });

    const legalFormSchema = LegalFormSchema(messages);
    const [canSubmit, setCanSubmit] = React.useState(false);
    const enableButton = () => setCanSubmit(true);
    const disableButton = () => setCanSubmit(false);

    const handleFormFieldChange = event => {
        const newForm = {
            ...form,
            [event.target.name]: event.target.value || ''
        };
        setForm(newForm);
    };

    useEffect(() => {
        setForm(legalState.form);
    }, [legalState.form]);

    return (<div className="container legal-content">
        <Heading>
            <Message code="epic.esport.guardian.title" />
        </Heading>
        <PrizeSpacer top={32}>
            <LoadingInspector loading={legalState.isLoading}>
            <Formsy
                onValid={enableButton}
                onInvalid={disableButton}
                className="tax-profile-form"
                onValidSubmit={updateGuardianInfoAct}>
                <div className="row form-wrapper col-xs-12 col-md-9 col-lg-9">
                    <ValidatingInput
                        customClassNames="col-xs-12 col-lg-6 tp-input"
                        name={legalFormSchema.guardianFirstName.identifier}
                        onChange={handleFormFieldChange}
                        value={form.guardianFirstName}
                        validations={legalFormSchema.guardianFirstName.validations}
                        validationErrors={legalFormSchema.guardianFirstName.validationMessages}
                        placeholder={getMessage(messages, 'epic.esport.label.profile.guardian.firstName')}
                        required
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-lg-6 tp-input"
                        name={legalFormSchema.guardianLastName.identifier}
                        onChange={handleFormFieldChange}
                        value={form.guardianLastName}
                        validations={legalFormSchema.guardianLastName.validations}
                        validationErrors={legalFormSchema.guardianLastName.validationMessages}
                        placeholder={getMessage(messages, 'epic.esport.label.profile.guardian.lastName')}
                        required
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-lg-6 tp-input"
                        name={legalFormSchema.guardianEmail.identifier}
                        onChange={handleFormFieldChange}
                        value={form.guardianEmail}
                        validations={legalFormSchema.guardianEmail.validations}
                        validationErrors={legalFormSchema.guardianEmail.validationMessages}
                        placeholder={getMessage(messages, 'epic.esport.label.profile.guardian.email')}
                        required
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-lg-6 tp-input"
                        name={legalFormSchema.guardianPhoneNumber.identifier}
                        onChange={handleFormFieldChange}
                        value={form.guardianPhoneNumber}
                        validations={legalFormSchema.guardianPhoneNumber.validations}
                        validationErrors={legalFormSchema.guardianPhoneNumber.validationMessages}
                        placeholder={getMessage(messages, 'epic.esport.label.profile.guardian.phone')}
                        required
                    />

                    <Text size={14} top={20} left={16}>
                        <Message code="epic.esport.guardian.notice" />
                    </Text>

                    <div className="submit-button-wrapper">
                        <Button disabled={legalState.isLoading || !canSubmit}>
                            <Message code="epic.esport.profile.saveChanges" />
                        </Button>
                    </div>
                </div>
            </Formsy>
            </LoadingInspector>
        </PrizeSpacer>
    </div>);
};

LegalContentWrapper.propTypes = {
    getGuardianInfo: PropTypes.func,
    updateGuardianInfo: PropTypes.func,
    legalState: PropTypes.object,
    messages: PropTypes.object
};

const mapStateToProps = () => {};

const mapDispatchToProps = {
    getGuardianInfo: LegalActions.getGuardianInfo,
    updateGuardianInfo: LegalActions.updateGuardianInfo
};

export const LegalContent = connect(
    mapStateToProps,
    mapDispatchToProps
)(LegalContentWrapper);

